/**
 * Prepopulation Default props used by all containers that consumes
 * the histogram MS enpoints.
 *
 * ----------- Containers using it --------
 *
 * - HeroMonthlyHistogramContainer
 * - HeroMonthlyHistogramContainerMobile
 * - LightMontlyHistogramContainer
 * - LightMontlyHistogramContainerMobile
 * - LowFareCalendarContainer
 * - LowFareCalendarContainerMobile
 */
import airportParams from './airports';

export default {
  siteEdition: '',
  airlineIataCode: 'nk',
  dataExpirationWindow: '1d',
  datePattern: 'MM/dd/yy',
  dateRange: { start: 0 },
  faresLimit: 1,
  flightType: 'ROUND_TRIP',
  interval: '1d',
  languageCode: 'en',
  outputFields: [
    'returnDate',
    'usdTotalPrice',
    'popularity',
    'originCity',
    'destinationCity',
    'destinationAirportImage',
    'destinationCityImage',
    'destinationStateImage',
    'destinationCountryImage',
    'destinationRegionImage',
    'farenetTravelClass',
    'travelClass',
    'flightDeltaDays',
    'totalPrice',
    'redemption',
    'flightType',
  ],
  budget: { maximum: null },
  markets: [],
  airport: { ...airportParams },
  priceFormat: { decimalSeparator: '.', thousandSeparator: ',', decimalPlaces: 0 },
  originCity: 'FLL',
  destinationCity: 'EWR',
  currencyPricingSettings: [
    {
      currencyCode: 'USD',
      priceFormat: {
        decimalSeparator: '.',
        thousandSeparator: ',',
      },
    },
  ],
};
